import type { ThemeMode } from "@jkast90/kast-common/theme";
import { setThemeMode, useThemeMode } from "../themePreference";
import Dropdown, { type DropdownOption } from "./Dropdown";

const OPTIONS: DropdownOption<ThemeMode>[] = [
  { value: "system", label: "System" },
  { value: "light", label: "Light" },
  { value: "dark", label: "Dark" },
];

/** Light, dark or the device's setting: the About page and the player's settings. */
export default function ThemeControl() {
  return <Dropdown value={useThemeMode()} options={OPTIONS} onChange={setThemeMode} label="Theme" />;
}
